import { render, staticRenderFns } from "./SocialAuth.vue?vue&type=template&id=6cc68451&scoped=true&"
import script from "./SocialAuth.vue?vue&type=script&lang=ts&"
export * from "./SocialAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc68451",
  null
  
)

export default component.exports